import React, { useMemo, useState, useEffect } from 'react';
import { Table, Pagination } from 'react-bootstrap';
import { getStatusKey } from './GradeQuadraLote';
import './ConsultaImoveis.css';

var ITENS_POR_PAGINA = 20;

var STATUS_LABELS = {
  bloqueado: 'Bloqueado',
  vendido: 'Vendido',
  carteira: 'Carteira',
  reservado: 'Reservado',
  pre_venda: 'Pré-Venda',
  alugado: 'Alugado',
  disponivel: 'Disponível',
  repasse: 'Repasse',
  proposta_rapida: 'Prop. Rápida',
  sem_tabela: 'Disp. s/Tabela',
  reserva_especial: 'Reserva Especial',
  reserva_casa: 'Reserva Casa',
};

var formatarMoeda = (valor) => {
  if (valor == null) return '-';
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

var formatarArea = (valor) => {
  if (valor == null) return '-';
  return `${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m²`;
};

var formatarInt = (valor) => (valor == null ? '-' : valor);

// Visualizacao tabular do mapa de lotes. Delphi dbGridLote renderiza
// apenas uma matriz quadra x posicao-lote (apenas o numero do lote em
// cada celula, com a cor codificando o status). No extranet web o modo
// Grid exibe, por linha, todos os campos descritivos do imovel que ja
// existem na query BuscarImoveisMapa.sql (alem dos campos base usados
// no mapa colorido).
var GridTabularImoveis = ({
  imoveis,
  onLoteDoubleClick,
  onLoteContextMenu,
  filtrosStatus,
  loading,
}) => {
  var filtros = filtrosStatus || [];

  var paginaState = useState(1);
  var pagina = paginaState[0]; var setPagina = paginaState[1];

  var linhas = useMemo(() => {
    if (!imoveis) return [];
    var ordenadas = imoveis.slice().sort((a, b) => {
      var q = (a.mapa1 || '').localeCompare(b.mapa1 || '', 'pt-BR', { numeric: true });
      if (q !== 0) return q;
      return (a.mapa2 || '').localeCompare(b.mapa2 || '', 'pt-BR', { numeric: true });
    });
    if (filtros.length === 0) return ordenadas;
    return ordenadas.filter((im) => filtros.indexOf(getStatusKey(im)) !== -1);
  }, [imoveis, filtros]);

  var totalPaginas = Math.max(1, Math.ceil(linhas.length / ITENS_POR_PAGINA));

  useEffect(() => {
    if (pagina > totalPaginas) setPagina(1);
  }, [totalPaginas, pagina]);

  useEffect(() => {
    setPagina(1);
  }, [imoveis, filtrosStatus]);

  var paginaAtual = Math.min(pagina, totalPaginas);
  var inicio = (paginaAtual - 1) * ITENS_POR_PAGINA;
  var linhasPagina = linhas.slice(inicio, inicio + ITENS_POR_PAGINA);

  if (loading) {
    return <div className="text-center p-4"><span>Carregando mapa...</span></div>;
  }

  if (!imoveis || imoveis.length === 0) {
    return (
      <div className="text-center p-4 text-muted">
        Selecione um empreendimento e clique em Buscar.
      </div>
    );
  }

  return (
    <div className="grid-tabular-container">
      <Table size="sm" bordered hover striped className="grid-tabular-imoveis mb-0">
        <thead>
          <tr>
            <th>Quadra</th>
            <th>Lote</th>
            <th>Status</th>
            <th>Cód. Ativo</th>
            <th className="text-right">Dorm.</th>
            <th className="text-right">Suítes</th>
            <th className="text-right">Banh.</th>
            <th className="text-right">Gar.</th>
            <th className="text-right">Área Constr.</th>
            <th className="text-right">Área Total</th>
            <th className="text-right">Preço Padrão</th>
            <th className="text-right">Preço Base</th>
            <th>Matrícula</th>
            <th>Cartório</th>
            <th>Cad. Pref.</th>
            <th>Endereço</th>
            <th>Bairro</th>
            <th>Marcadores</th>
          </tr>
        </thead>
        <tbody>
          {linhasPagina.map((imovel) => {
            var statusKey = getStatusKey(imovel);
            var marcadores = [];
            if (imovel.tem_reserva_especial === 1) marcadores.push('Res. Especial');
            if (imovel.tem_reserva_casa === 1) marcadores.push('Res. Casa');
            if (imovel.tem_repasse === 1) marcadores.push('Repasse');
            if (imovel.extra === '*') marcadores.push('Ticket');
            return (
              <tr
                key={`${imovel.mapa1}-${imovel.mapa2}-${imovel.codigo_ativo}`}
                onDoubleClick={() => onLoteDoubleClick && onLoteDoubleClick(imovel)}
                onContextMenu={(e) => {
                  e.preventDefault();
                  onLoteContextMenu && onLoteContextMenu(e, imovel);
                }}
                style={{ cursor: 'pointer' }}
              >
                <td>{imovel.mapa1}</td>
                <td>
                  {imovel.mapa2}
                  {imovel.extra === '*' ? '*' : ''}
                </td>
                <td>{STATUS_LABELS[statusKey] || statusKey}</td>
                <td>{imovel.codigo_ativo}</td>
                <td className="text-right">{formatarInt(imovel.dormitorios)}</td>
                <td className="text-right">{formatarInt(imovel.suites)}</td>
                <td className="text-right">{formatarInt(imovel.banheiros)}</td>
                <td className="text-right">{formatarInt(imovel.garagem)}</td>
                <td className="text-right">{formatarArea(imovel.area_construida)}</td>
                <td className="text-right">{formatarArea(imovel.area_total)}</td>
                <td className="text-right">{formatarMoeda(imovel.preco_padrao)}</td>
                <td className="text-right">{formatarMoeda(imovel.preco_base)}</td>
                <td>{imovel.matricula || '-'}</td>
                <td>{imovel.cartorio || '-'}</td>
                <td>{imovel.cad_pref || '-'}</td>
                <td>{imovel.endereco || '-'}</td>
                <td>{imovel.bairro || '-'}</td>
                <td className="text-muted" style={{ fontSize: 11 }}>
                  {marcadores.length > 0 ? marcadores.join(' · ') : '-'}
                </td>
              </tr>
            );
          })}
          {linhas.length === 0 && (
            <tr>
              <td colSpan={18} className="text-center text-muted py-3">
                Nenhum lote para os filtros selecionados.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {linhas.length > 0 && (
        <div className="grid-tabular-paginacao">
          <span className="text-muted" style={{ fontSize: 11 }}>
            Exibindo {inicio + 1}–{Math.min(inicio + ITENS_POR_PAGINA, linhas.length)} de {linhas.length}
          </span>
          {totalPaginas > 1 && (
            <Pagination size="sm" className="mb-0">
              <Pagination.First
                onClick={() => setPagina(1)}
                disabled={paginaAtual === 1}
              />
              <Pagination.Prev
                onClick={() => setPagina(paginaAtual - 1)}
                disabled={paginaAtual === 1}
              />
              <Pagination.Item active>{paginaAtual} / {totalPaginas}</Pagination.Item>
              <Pagination.Next
                onClick={() => setPagina(paginaAtual + 1)}
                disabled={paginaAtual === totalPaginas}
              />
              <Pagination.Last
                onClick={() => setPagina(totalPaginas)}
                disabled={paginaAtual === totalPaginas}
              />
            </Pagination>
          )}
        </div>
      )}
    </div>
  );
};

export default GridTabularImoveis;
